import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { FamilyAccountInfo } from '@backrs_ui/grow-ui/src/redux/family/family.types';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { FamilyMembersTable } from './FamilyMembersTable';

const {
  modules: {
    accountSettings: {
      family: {
        sections: {
          members: { title, description },
        },
      },
    },
  },
} = appStrings;

type ViewFamilyMembersProps = Readonly<{
  familyAccount: FamilyAccountInfo | undefined;
  returnToDefaultTab: () => void;
}>;

export const ViewFamilyMembers = ({
  familyAccount,
  returnToDefaultTab,
}: ViewFamilyMembersProps) => {
  const { members = [], invites = [] } = familyAccount || {};
  const owner = familyAccount?.familyAccount?.owner;
  const isOwner = familyAccount?.role === 'owner';

  return (
    <Box sx={containerSx}>
      <Box>
        <Typography
          variant="text-sm-semibold"
          color={({ backrs }) => backrs.colors['Colors/Text/text-secondary']}
        >
          {title}
        </Typography>
        <Typography
          variant="text-sm-regular"
          color={({ backrs }) => backrs.colors['Colors/Text/text-tertiary']}
        >
          {description}
        </Typography>
      </Box>
      <FamilyMembersTable
        owner={owner}
        members={members}
        invites={invites}
        isOwner={isOwner}
        returnToDefaultTab={returnToDefaultTab}
      />
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  marginTop: backrs.spacing['spacing-4xl'],
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
  '@media (min-width: 700px)': {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
    gap: backrs.spacing['spacing-4xl'],
  },
});
